// Identify user in GTM
export function identifyGTM(user) {
    if (!window.dataLayer) return;
    window.dataLayer.push({ userId: user.uid });
}

// Track an event in GTM
export function trackGTM(event, flushEvent) {
    if (!window.dataLayer) return;
    // Flush the full event to prevent GTM from re-firing previous event
    window.dataLayer.push(flushEvent);
    window.dataLayer.push(event);
}
